// ---- init ----
let cookies = parse();

// ---- METHODS ----
function parse() {
    return document.cookie.split(';').reduce((obj, cookie) => {
        let parts = cookie.trim().split('='),
            key = parts[0],
            val = parts[1];
        if (key && key.length) obj[key] = tryJSONParse(val);
        return obj
    }, {});
}

function tryJSONParse(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return str;
    }
}

function get(name) {
    return cookies[name];
}

function set(name, val) {
    cookies[name] = val;
    document.cookie = `${name} = ${JSON.stringify(val)}`;
}

export default {
    get,
    set
}